import { Component, OnInit } from '@angular/core';
import { FormControlService } from './../../shared/services/form-control.service';
import { Textbox } from './../../models/editors/textbox.model';
import { Textarea } from './../../models/editors/textarea.model';
import { About } from './../../models/about/about.model';
import { ApiService } from './../../shared/services/api.service';
import { AlertService } from './../../shared/services/alert.service';
import { InlineFormBase } from './../../shared/components/base/inline-form/inline-form.base.component';
import { Contained } from '../../models/editors/contained.model';
import { atLeastOneLang } from '../../shared/validators/langField.validator';

@Component({
  selector: 'swb-about',
  templateUrl: './../../shared/components/base/inline-form/inline-form.base.component.html',
  providers: [FormControlService]
})

export class AboutComponent extends InlineFormBase<About> implements OnInit {

  public url = 'about';

  public headerTitle = 'O nás';
  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Titulek',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textarea({
        key: 'content',
        label: 'Text o nás',
        validators: [atLeastOneLang],
        isMultilang: true,
        wysiwyg: 'about'
      }),
      new Contained({
        key: 'file_id',
        label: 'Obrázek',
        isMultilang: false,
        upload: true,
        imgOnly: true,
        entity: this.entity.file
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _alertService: AlertService
  ) {
    super(
      _formService,
      _apiService,
      _alertService
    );
  }

}
